import { ChangeDetectionStrategy, Component, input, computed } from "@angular/core";
import "./meter.component.scss";

@Component({
  selector: "app-meter",
  templateUrl: "./meter.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeterComponent {
  variant = input<"circle" | "bar">("bar");
  value = input<number, number | string>(0, {
    transform: (v) => {
      const num = Number(v);
      return Number.isNaN(num) ? 0 : num;
    },
  });

  // 1. Add sizing inputs (with defaults matching your current design)
  // size accepts any valid CSS string: 'tw-w-32 tw-h-32', '120px', '8rem', etc.
  size = input<string>("tw-w-32 tw-h-32");
  strokeWidth = input<number>(8); // Controlled relative to the 100x100 viewBox

  protected readonly strokeArray = 2 * Math.PI * 40; // Always ~251.2 since r=40 is a fixed scale ratio

  protected percentage = computed(() => this.value() * 100);

  protected strokeOffset = computed(() => {
    const boundedValue = Math.max(0, Math.min(1, this.value()));
    return this.strokeArray * (1 - boundedValue);
  });

  protected meterColor = computed(() => {
    const val = this.percentage();
    if (val <= 60) {
      return "meter-primary";
    }
    if (val <= 80) {
      return "meter-orange";
    }
    return "meter-danger";
  });
}
